import React from 'react';
import '../styles/SearchBar.css';

interface SearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({ 
  searchQuery, 
  onSearchChange, 
  placeholder = "Search leads by Customer Name..." 
}) => {
  return (
    <div className="search-bar-container">
      <input
        type="text"
        placeholder={placeholder}
        className="search-bar-input"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
      />
     
    </div>
  );
};

export default SearchBar;